<template>
  <b-skeleton-wrapper :loading="isLoading">
    <template #loading>
      <b-row>
        <b-col v-for="n in 3" :key="n">
          <b-skeleton width="75%" />
          <b-skeleton width="50%" />
        </b-col>
      </b-row>
    </template>
    <ReadOnly :items="items" />
  </b-skeleton-wrapper>
</template>

<script>
import ReadOnly from './index'
import { deliveryReadOnly } from '../../lib/constants/read-only-items'
import get from 'lodash/get'

export default {
  components: {
    ReadOnly,
  },
  inject: ['isLoading'],
  props: {
    showResponse: {
      type: Object,
    },
  },
  computed: {
    items() {
      return deliveryReadOnly(this.$t.bind(this)).map((item) => ({
        ...item,
        value: get(this.showResponse, item.key) || '-',
      }))
    },
  },
}
</script>
